import React from 'react';
import PropTypes from 'prop-types';

const Text = ({
  size,
  importance,
  align,
  children,
}) => (
  <div
    size={size}
    importance={importance}
    align={align}
  >
    {children}
  </div>
);

const propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf([
    'small',
    'default',
    'large',
  ]),
  importance: PropTypes.oneOf([
    'low',
    'default',
    'high',
  ]),
  align: PropTypes.oneOf([
    'center',
  ]),
};

const defaultProps = {
  children: null,
  size: 'default',
  importance: 'default',
  align: null,
};

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export default Text;

export {
  propTypes,
  defaultProps,
};
